<template>
  <card shadow class="card-profile b-2" style="width: 100%; color: black;" no-body>
    <div class="px-4">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h1 class="display-3 mt-3">Программын жагсаалт</h1>
        <div class="d-flex align-items-center">
          <input type="text" v-model="searchQuery" class="form-control mr-2"
            placeholder="Иконоор эсвэл холбоосоор хайх..." />
          <button class="btn btn-success" @click="openCreateModal">Үүсгэх</button>
        </div>
      </div>

      <table class="table" v-if="filteredIcons.length">
        <thead>
          <tr>
            <th>Программын Икон</th>
            <th>Холбоос</th>
            <th>Төлөв</th>
            <th class="text-right">Үйлдлүүд</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="icon in filteredIcons" :key="icon.link">
            <td>
              <img :src="icon.icon" alt="Icon" style=" height: 50px;" />
            </td>
            <td>
              <a :href="icon.link" target="_blank">{{ icon.link }}</a>
            </td>
            <td>

              <span :style="{
                backgroundColor: icon.active ? '#d1fae5' : '#e5e7eb',
                color: icon.active ? '#065f46' : '#4b5563',
                padding: '4px 12px',
                borderRadius: '9999px',
                fontWeight: '500',
                fontSize: '14px',
                display: 'inline-block'
              }"> {{ icon.active ? "Харуулах" : "Харуулахгүй" }} </span>
            </td>
            <td class="td-actions text-right">
              <button type="button" class="btn btn-info btn-sm" @click="openEditModal(icon)">
                <i class="fa fa-pencil pt-1"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <Modal :show.sync="showModal">
      <div class="modal-header">
        <h3>{{ isEditing ? 'Засах' : 'Үүсгэх' }} Икон</h3>
      </div>
      <form @submit.prevent="handleSubmit">
        <div class="form-group">
          <label>Холбоос</label>
          <input v-model="iconData.link" class="form-control" type="text"
            placeholder="http://  эсвэл  https:// -р эхлүүлнэ үү" />
        </div>

        <div class="form-group">
          <label>Икон</label>
          <input ref="iconInput" type="file" @change="onFileChange" class="form-control" accept=".png, .jpg, .jpeg"
            hidden />
          <div class="file-upload-info">
            <span v-if="iconName">{{ iconName }}</span>
            <span v-else>Икон файл сонгоно уу</span>
            <base-button type="info" class="browse-button" @click="$refs.iconInput.click()">
              Файл сонгох
            </base-button>
          </div>
          <img v-if="iconData.icon" :src="iconData.icon" alt="Icon" style=" height: 50px; margin-top: 10px;" />
        </div>

        <div class="toggle">
          <input type="checkbox" v-model="iconData.active" :id="'status-toggle'" style="margin-bottom: 6px;" />
          <label :style="{
            backgroundColor: iconData.active ? '#d1fae5' : '#e5e7eb',
            color: iconData.active ? '#065f46' : '#4b5563',
            padding: '4px 12px',
            borderRadius: '9999px',
            fontWeight: '500',
            fontSize: '14px',
            display: 'inline-block'
          }" :for="'status-toggle'">
            {{ iconData.active ? "Харуулах" : "Харуулахгүй" }}
          </label>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeModal">Цуцлах</button>
          <button :disabled="!(iconData.icon && iconData.link)" type="submit" class="btn btn-primary">Хадгалах</button>
        </div>
      </form>
    </Modal>
  </card>
</template>

<script>
import axios from "axios";
import Modal from "@/components/Modal.vue";

export default {
  name: "ProgramIcons",
  data() {
    return {
      iconList: [],
      iconData: {
        id: null,
        icon: "",
        link: "",
        active: true,
      },
      iconName: '',
      showModal: false,
      searchQuery: "",
      isEditing: false,
      file: null,
    };
  },
  created() {
    this.fetchIconList();
  },
  computed: {
    filteredIcons() {
      let icons = [...this.iconList];
      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase();
        icons = icons.filter(icon =>
          icon.link.toLowerCase().includes(query)
        );
      }
      return icons;
    }
  },
  methods: {
    fetchIconList() {
      axios.get("/link_list")
        .then(response => {
          this.iconList = response.data;
        })
        .catch(error => console.error("Error fetching icons:", error));
    },

    onFileChange(event) {
      const file = event.target.files[0];
      if (!file) return;

      const validTypes = ["image/jpeg", "image/png", "image/jpg"];
      if (!validTypes.includes(file.type)) {
        this.$alert.showAlert("Зөвхөн JPG, JPEG эсвэл PNG зураг сонгоно уу", "error");
        this.iconName = '';
        this.iconData.icon = '';
        return;
      }

      this.iconName = file.name;

      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement("canvas");
          const scale = 80 / img.height;
          const width = img.width * scale;
          const height = 80;

          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, width, height);

          const resizedDataUrl = canvas.toDataURL(file.type);
          this.iconData.icon = resizedDataUrl;
        };
        img.src = e.target.result;
      };

      reader.readAsDataURL(file);
    },

    async uploadFile() {
      if (!this.file) return Promise.resolve(null);
      const formData = new FormData();
      formData.append('file', this.file);
      return axios.post('/link', formData)
        .then(response => response.data.url)
        .catch(error => {
          console.error('Error uploading file:', error);
          throw error;
        });
    },

    openCreateModal() {
      this.isEditing = false;
      this.iconData = { icon: "", link: "", active: true };
      this.file = null;
      this.showModal = true;
    },

    openEditModal(icon) {
      this.isEditing = true;
      this.iconData = { ...icon };
      this.file = null;
      this.showModal = true;
    },

    closeModal() {
      this.showModal = false;
    },

    async handleSubmit() {
      try {
        if (!/^https?:\/\//.test(this.iconData.link)) {
          this.$alert.showAlert("Холбоос http:// эсвэл https:// -р эхлэх ёстой", "error");
          return;
        }
        if (this.isEditing) {
          await axios.put(`/link/${this.iconData.id}`, this.iconData);
        } else {
          await axios.post(`/link`, this.iconData);
        }

        this.fetchIconList();
        this.iconData = { icon: "", link: "" };
        this.$refs.iconInput.value = '';
        this.iconName = '';
        this.closeModal();
        this.$alert.showAlert("Амжилтай хадгалагдлаа", "success");
      } catch (error) {
        this.$alert.showAlert("Error saving icon:", "error");
      }
    },
  },
  components: {
    Modal,
  },
};
</script>

<style scoped>
.btn-link {
  text-decoration: none;
  color: inherit;
  padding: 0;
}

.btn-link:hover {
  text-decoration: none;
  color: inherit;
}

.toggle {
  display: flex;
  align-items: center;
}

.toggle input {
  margin-right: 8px;
}
</style>
